"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; //
//
//
//
//
//
//
//
//
//
//
//
//

var _default2 = {
  name: 'ebook-card-render',
  props: {
    data: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    cardDetails: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  }
};
exports["default"] = _default2;